import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const campaignSelector = createFeatureSelector<IState>('campaign');
export const getCampaignsSelector = createSelector(campaignSelector, (state: IState) => state); 
export const getCampaignSelector = createSelector(campaignSelector, (state: IState) => state.selectedItem); 
